import { useEffect } from "react";
import "./styles/certificate_form.css";
import CalculateAge from "../../utils/computeAgeUtils";
import getRelationship from "../../utils/getRelationship";


function getOrdinalSuffix(day) {
    if (day > 3 && day < 21) return 'th'; // covers 11th to 20th
    switch (day % 10) {
        case 1      : return 'st';
        case 2      : return 'nd';
        case 3      : return 'rd';
             default: return 'th';
    }
}

// Utility function to format the date
function formatDate(dateString, format) {
    const date          = new Date(dateString);
    const day           = date.getDate();
    const monthLong     = date.toLocaleString('default', { month: 'long' });
    const monthShort    = date.toLocaleString('default', { month: 'short' });
    const year          = date.getFullYear();
    const ordinalSuffix = getOrdinalSuffix(day);

    switch (format) {
        case 'MM DD, YYYY': 
            return `${monthLong} ${day}, ${year}`;
        case 'MM DDth, YYYY': 
            return `${monthLong} ${day}${ordinalSuffix}, ${year}`;
        case 'Day of Month, YYYY': 
            return `${day}${ordinalSuffix} day of ${monthLong}, ${year}`;
        default: 
            return `${monthLong} ${day}, ${year}`;
    }
}


const DynamicMessage = ({details,updateHasPhoto,updateHasThumbmark,updateHasSignature}) => {

    const currentDate = new Date();
    const formattedDate = formatDate(currentDate,'Day of Month, YYYY');


    const personType = details.cert_for === "self" ? "client" : "beneficiary";

    const message_header           = `<h1 class="text-center mt-2 header-text">${details.cert_type?.toUpperCase()}</h1>`;
    const message_date             = `<p class="text-end my-5">${formatDate(currentDate,'MM DD, YYYY')}<p>`;
    const message_greeting         = `<p class="mt-5 mb-3">TO WHOM IT MAY CONCERN:</p>`;
    const message_issuance_purpose = `<p style="text-indent: 5em;" >This certification is issued upon the request of <b>${details[`client_fullname`]}</b> for the purpose: <b>${details['cert_purpose']}</b></p>`;
    const message_footer           = `<p style="text-indent: 5em;" >Issued this <b>${formattedDate}</b> at Barangay Bahay Toro, Quezon City, Metro Manila.</p>`;
    const message_validity         = `<p>This certification is valid only for (1) year from date of issuance.</p>`;
    

    const barangay_clearance_message_repeating = `${message_header}
                                                    <p class="mt-5 mb-3">TO WHOM IT MAY CONCERN:</p>

                                                    <p style="text-indent: 5em;" >
                                                        This is to certify that 
                                                        <b>${details[`${personType}_fullname`]}</b>
                                                        and presently residing at

                                                        <b>${details[`${personType}_address`]}</b>
                                                        has been a resident of Barangay Bahay Toro, Quezon City, Metro since 

                                                        <b>${details.year_of_residency}</b>
                                                        up to present..</b></i>
                                                    </p>

                                                    ${message_issuance_purpose}


                                                    <p style="text-indent: 5em;" >
                                                        Issued this <b>${formattedDate}</b> at Barangay Bahay Toro, Quezon City, Metro Manila.
                                                    </p>`;


    const certificate_of_indigency_message_repeating = `
            ${message_header}
            ${message_date}
            <p style="text-indent: 5em;" >
                This is to certify that 
                <b>${details[`${personType}_fullname`]}</b>,
                <b>${CalculateAge(details[`${personType}_birthdate`])}</b> year(s) old
                is a bonafide resident of
                <b>${details[`${personType}_address`]}</b>.
            </p>
            <p style="text-indent: 5em;" >This certification is issued upon the request of <b>${details['client_fullname']}</b> for <b>${details['cert_purpose']}</b> </p>
    `;

 


    const upperCasePurpose = details['cert_purpose'].toUpperCase();

    let final_footer_for_certificate_of_indigency = ``;
    if (upperCasePurpose === "SCHOLARSHIP (CHED)") {
        final_footer_for_certificate_of_indigency= 'in connection with the “Scholarship Application” given by Commission on Higher Education (CHED)';
    } else if (upperCasePurpose === "SCHOLARSHIP (SPES)") {
        final_footer_for_certificate_of_indigency= 'to avail the <b>Special Program for Employment of Students (SPES)</b> given by the <b>Public Employment Service Office (PESO), Quezon City</b>';
    } else {
        final_footer_for_certificate_of_indigency= `for any possible educational/financial assistance for <b>${details['cert_purpose'].toUpperCase()}</b>`;
    }
 

    const certificate_of_indigency_scholarship=`
                                                    ${message_header}
                                                    ${message_date}
                                                        <p style="text-indent: 5em;" >
                                                            This is to certify that <b>${details['client_fullname']}</b>,  is a bonafide resident of <b>${details['client_address']}</b>

                                                            ${details.cert_for === "self" ? '':
                                                            `
                                                                and ${details['relationship_to_beneficiary'].toLowerCase()} of <b>${details['beneficiary_fullname']}</b>
                                                            `}
                                                            .
                                                        </p>

                                                        <p style="text-indent: 5em;" >It is further certified that said <b>${details['client_fullname']}</b> claims that their family income is barely enough for their daily subsistence

                                                            ${details.cert_for === "self" ?
                                                            
                                                            `and cannot support the education needs`
                                                            :
                                                            `
                                                                thus cannot meet the educational/financial requirement needs of ${details['client_gender']==="male" ? 'his':'her' } ${getRelationship(details['relationship_to_beneficiary'],details['beneficiary_gender']).toLowerCase()} <b>${details['beneficiary_fullname']}</b>
                                                            `}.
                                                        </p>

                                                        <p style="text-indent: 5em;" >This certification is issued upon the request of <b>${details['client_fullname']}</b>,
                                                        ${final_footer_for_certificate_of_indigency}
                                                        and for whatever purpose it may serve.</p>
                                                `;




    const certificate_of_residency_message = `
                                                    ${message_header}
                                                    ${message_greeting}

                                                    <p style="text-indent: 5em;" >
                                                        This is to certify that <b>${details[`${personType}_fullname`]}</b>, born on
                                                        <b>${formatDate(details[`${personType}_birthdate`],'MM DD, YYYY')}</b>,
                                                        <b>${details[`${personType}_civil_status`]}</b>,
                                                        is a bonafide resident of <b>${details['client_address']}</b> since ${details['year_of_residency']} up to present.
                                                    </p>


                                                    <p style="text-indent: 5em;" >
                                                        The undersigned has certified that after a reasonable inquiry, I have verified the authenticity of barangay residency showing that the applicant has been residing in the barangay for atleast six (6) months prior to the application of this <b>Affidavit of Residency</b>. 
                                                    </p>

                                                    <p style="text-indent: 5em;" >
                                                        This certification is issued upon the request of the above-named person as a supporting document for <b>${details['cert_purpose']}</b>.
                                                    </p>

                                                    ${message_footer}
                                            `;

    const templates = [
        { purpose: 'FIRST-TIME JOB SEEKER', with_picture: 'true',with_residence_since: 'true',
            message:
            `
                ${message_header}
                ${message_greeting}
                

                <p style="text-indent: 5em;" >
                        This is to certify that 
                    <b>${details[`${personType}_fullname`]}</b>
                        a resident of <b>${details[`${personType}_address`]}</b>, since ${details.year_of_residency}, is a qualified availed of <i><b>RA 11261 or the First Time Jobseekers Act of 2019.</b></i>
                </p>

                <p style="text-indent: 5em;" >
                    I further certify that the holder/bearer was informed of his/her rights, including the duties and responsibilities accorded by RA 11261 through the Oath of Undertaking he/she signed and executed in the presence of our Barangay Official.
                </p>

                ${message_footer}
                ${message_validity}
                
            `
        },



        { purpose: 'LATE BIRTH', with_picture: 'true', with_residence_since: 'true',
            message:
            `
                ${message_header}
                ${message_greeting}

                <p style="text-indent: 5em;" >
                    This is to certify that 
                    <b>${details[`${personType}_fullname`]},</b>
                    <b>${CalculateAge(details[`${personType}_birthdate`])}</b> year(s) old,
                    ${details[`${personType}_civil_status`]},
                    was born on 
                    <b>${formatDate(details[`${personType}_birthdate`],'MM DD, YYYY')}</b>
                    at
                    <b>${details[`${personType}_place_of_birth`]},</b>
                    is a resident of
                    <b>${details[`${personType}_address`]}</b>
                    of Barangay Bahay Toro, Quezon City, Metro Manila up to present.
                </p>

                ${message_issuance_purpose}
                ${message_footer}
            `
        },


        { purpose: 'LOCAL EMPLOYMENT',      with_picture: 'true', with_residence_since: 'true', message: barangay_clearance_message_repeating},
        { purpose: 'RESIDENCY',             with_picture: 'true', with_residence_since: 'true', message: barangay_clearance_message_repeating},


        { purpose: 'UNBOUND ELDERLY FOUNDATION' ,message:certificate_of_indigency_message_repeating},
        { purpose: 'SWA'                        ,message:certificate_of_indigency_message_repeating},
        { purpose: 'SWA PDAO'                   ,message:certificate_of_indigency_message_repeating},
        { purpose: 'SSDD CAPITAL'               ,message:certificate_of_indigency_message_repeating},
        { purpose: 'PHILHEALTH'                 ,message:certificate_of_indigency_message_repeating},
        { purpose: 'PAO'                        ,message:certificate_of_indigency_message_repeating},
        { purpose: 'MERALCO LIFELINE DISCOUNT'  ,message:certificate_of_indigency_message_repeating},
        { purpose: 'MEDICAL FINANCIAL ASST'     ,message:certificate_of_indigency_message_repeating},
        { purpose: 'DSWD'                       ,message:certificate_of_indigency_message_repeating},
        { purpose: 'DOG BITE'                   ,message:certificate_of_indigency_message_repeating},


        { purpose: 'BURIAL ASSISTANCE',
                                    message:
                                    `   
                                    ${message_header}
                                    ${message_date}
                                        <p style="text-indent: 5em;" >
                                            This is to certify that <b>${details['client_fullname']}</b>, ${CalculateAge(details[`client_birthdate`])} years old is a bonafide resident of <b>${details['client_address']}</b>.
                                        </p>

                                        <p style="text-indent: 5em;" >It is further certified that said <b>${details['client_fullname']}</b> claims that their family income is barely enough for their daily subsistence thus cannot meet the Burial Assistance requirements need of his late ${details['relationship_to_beneficiary']} <b>${details['beneficiary_fullname']}</b></p>

                                        <p style="text-indent: 5em;" >This certification is issued upon the request of <b>${details['client_fullname']}</b> for any possible burial/financial assistance and for whatever purpose it may serve.</p>
                                    `},


        { purpose: 'BALIK PROBINSYA',
            message:
            `
                ${message_header}
                ${message_date}
                <p style="text-indent: 5em;" >
                    This is to certify that

                    ${details['requestor_is_beneficiary'] && `<b>${details['client_fullname']}, </b>` }

                    ${details['balik_probinsya'].map((beneficiary,index) => {
                        const isLast = index === details['balik_probinsya'].length - 1;
                        const isSecondLast = index === details['balik_probinsya'].length - 2;
                        return isLast ? `and <b>${beneficiary.beneficiary_fullname}</b>` : isSecondLast ? `<b>${beneficiary.beneficiary_fullname}</b> ` : `<b>${beneficiary.beneficiary_fullname}</b>, `;
                      }).join('')
                    }
                    are bonafide resident of <b>${details['balik_probinsya_address']}</b> and desirous to go back to their province at <b>${details['balik_probinsya_address_province']}</b>.
                </p>

                <p style="text-indent: 5em;" >That this certification is issued upon the request of 
                <b>${details['client_fullname']}</b>
                to avail the <b>“Balik Probinsya Program Financial Assistance</b> given by 
                <b>Department of Social Welfare and Development (DSWD)</b> and for whatever purpose it may serve.</p>
            `
        },
        { purpose: 'DSWD EDUCATIONAL ASSISTANCE'    ,message:certificate_of_indigency_scholarship},
        { purpose: 'SCHOLARSHIP (CHED)'             ,message:certificate_of_indigency_scholarship},
        { purpose: 'SCHOLARSHIP (QCYDO)'            ,message:certificate_of_indigency_scholarship},
        { purpose: 'SCHOLARSHIP APPLICATION'        ,message:certificate_of_indigency_scholarship},
        { purpose: 'SCHOLARSHIP APPLICATION (DOST)' ,message:certificate_of_indigency_scholarship},
        { purpose: 'SCHOOL REQUIREMENT'             ,message:certificate_of_indigency_scholarship},
        { purpose: 'SCHOLARSHIP (SPES)'             ,message:certificate_of_indigency_scholarship},

        { purpose: 'PWD ID',    with_picture: 'true', with_residence_since: 'true',with_thumbmark: 'true',with_signature: 'true', message:certificate_of_residency_message },
        { purpose: 'QC ID',     with_picture: 'true', with_residence_since: 'true',with_thumbmark: 'true',with_signature: 'true', message:certificate_of_residency_message },
        { purpose: 'SENIOR',    with_picture: 'true', with_residence_since: 'true',with_thumbmark: 'true',with_signature: 'true', message:certificate_of_residency_message },

        { purpose: 'COHABITATION', with_picture: 'true', with_residence_since: 'true',with_thumbmark: 'false', with_partner_since:'true', 
            message: 
                    `
                        ${message_header}
                        ${message_greeting}
                        <p style="text-indent: 5em;" >
                            This is to certify that, as per records submitted,
                            
                            <b> ${details['client_gender'].toLowerCase()==="male" ? 'MR.' : 'MS.'} ${details['client_fullname']}</b> and
                            <b>
                                ${details['beneficiary_gender'] && details['beneficiary_gender'].toLowerCase() === "male" ? 'MR.' : (details['beneficiary_gender'] && details['beneficiary_gender'].toLowerCase() === "female" ? 'MS.' : '')} 
                                ${details['beneficiary_fullname']}
                            </b>

                            has been living together/cohabitating each other as live in partner since ${details['year_of_partnership']} at ${details['client_address']}.
                        </p>

                        <p style="text-indent: 5em;" >This certification is issued this ${formattedDate} upon the request of <b>${details['client_fullname']}</b> for whatever legal purpose it may serve.</p>
                    `
         },
        { purpose: 'GOOD MORAL',
            message:
            `
                ${message_header}
                ${message_greeting}

                <p style="text-indent: 5em;" >
                    This is to certify that the verification conducted by this office that 
                    <b>${details['client_fullname']}</b> and presently residing at 
                    <b>${details['client_address']}</b>  has no derogatory Records or any related violence on file in this Barangay as of date.
                </p>

                <p style="text-indent: 5em;" >
                    This certification is issued upon the request of subject person for the purpose to attest to the fact that he/she is of 
                    <b>GOOD MORAL CHARACTER</b>, and no record under BADAC for whatever purpose it may serve.
                </p>

                ${message_footer}
            `
        },
        { purpose: 'GUARDIANSHIP CERTIFICATION',
            message:
            `
                ${message_header}
                ${message_greeting}

                <p style="text-indent: 5em;" >
                    This is to certify that, as per documents submitted of
                    <b>${details['client_fullname']}</b> is a resident of 
                    <b>${details['client_address']}</b> and 
                    <b>${details['relationship_to_beneficiary']}</b> of 
                    <b>${details['beneficiary_fullname']}
                </p>

                <p style="text-indent: 5em;" >This certification is issued this ${formattedDate} upon the request of <b>${details['client_fullname']}</b> for whatever legal purpose it may serve.</p>
            `
        },
        { purpose: 'NON RESIDENCY',
            message:
            `
                ${message_header}
                ${message_greeting}

                <p style="text-indent: 5em;" >
                    This is to certify that a verification conducted by the 
                    <b>Barangay Public Safety Officer (BPSO)</b>, this office, revealed that
                    <b>${details['beneficiary_fullname']}</b>, formerly residing at 
                    <b>${details['client_address']}</b> ), cannot be located and or nowhere to be found at the said address.
                </p>
                
                <p style="text-indent: 5em;" >This certification is issued upon the request of <b>${details['client_fullname']}</b> and for whatever purpose it may serve.</p>

                ${message_footer}

            `
        },
        { purpose: 'NOT COVID TEST',
            message:
            `
                ${message_header}
                ${message_greeting}

                <p style="text-indent: 5em;" >
                    This is to certify that ${details[`${personType}_fullname`]} a resident of 
                    <b>${details[`${personType}_address`]}</b> has not yet undergone any medical tests for COVID-19.
                </p>
                
                <p style="text-indent: 5em;" >This certification is issued this ${formattedDate} upon the request of <b>${details['client_fullname']}</b> for whatever legal purpose it may serve.</p>

                ${message_footer}

            `
        },
        { purpose: 'NOT PUI PUM COVID TEST',
            message:
            `
                ${message_header}
                ${message_greeting}

                <p style="text-indent: 5em;" >
                    This is to certify that ${details[`${personType}_fullname`]} a resident of 
                    <b>${details[`${personType}_address`]}</b> is not a Person Under Investigation or PUI/PUM or positive of COVID-19.
                </p>
                
                <p style="text-indent: 5em;" >This certification is issued this ${formattedDate} upon the request of <b>${details['client_fullname']}</b> for whatever legal purpose it may serve.</p>

                ${message_footer}

            `
        },


        { purpose: 'PWD ID', with_picture: 'true',
            message:
            `
                ${message_header}
                ${message_greeting}

                <p style="text-indent: 5em;">
                    This is to certify that, per record submitted and evaluation made, 
                    <b>${details[`${personType}_fullname`]}</b> and presently residing at 
                    <b>${details[`${personType}_address`]}</b>  and found to be a <b>“PERSON WITH DISABILITY”</b> and as such is entitled to the privileges provided under <b> Republic Act No. 7277</b> .
                </p>

                <p style="text-indent: 5em;">This certification is issued upon the request of subject person for the purpose of <b>PWD ID</b>.</p>
                
                ${message_footer}
            `

        },
        { purpose: 'SOLO PARENT',
            message:
            `
                ${message_header}
                ${message_greeting}

                <p style="text-indent: 5em;">
                    This is to certify that based on the documents submitted the bearer, 
                    <b>${details[`${personType}_fullname`]}</b>, 
                    <b>${CalculateAge(details[`${personType}_birthdate`])}</b> year(s) old, a resident of 
                    <b>${details[`${personType}_address`]}</b>,

                    appears to be a <b>“Solo Parent”</b> as provided in Sec. 3 (a) (8), R.A. 8972. Otherwise known as <b>“THE SOLO PARENT’S WELFARE ACT OF 2000”</b>.  
                </p>

                <p style="text-indent: 5em;">This certification is issued her request and for whatever benefits that the Solo Welfare Act of 2000 will provide.</p>
            `
        },
        { purpose: 'TRANSFER ADDRESS',
            message:
            `
                ${message_header}
                ${message_greeting}

                <p style="text-indent: 5em;">
                    This is to certify that <b>${details[`${personType}_fullname`]}</b>, 
                    as verification-conducted, is a previous resident of 
                    <b>${details[`${personType}_address`]}</b>,
                    City and currently transferred her residence at 
                    <b>${details[`transfer_address`]}</b>.
                </p>

                <p style="text-indent: 5em;">It is further certified that <b>${details[`${personType}_fullname`]}</b> is not a resident of Barangay Bahay Toro.</p>

                <p style="text-indent: 5em;" >This certification is issued this ${formattedDate} upon the request of <b>${details['client_fullname']}</b> for whatever legal purpose it may serve.</p>
            `
        },
        { purpose: 'VISA EXTENSION',
            message:
            `
                ${message_header}
                ${message_greeting}

                <p style="text-indent: 5em;">
                    This is to certify, as per documents submitted, 
                    <b>${details[`${personType}_fullname`]}</b>, 
                    a native of 
                    <b>${details[`visa_native_of`]}</b>,
                    is now residing at
                    <b>${details[`${personType}_address`]}</b>

                    from ${formatDate(details[`visa_staying_since`],'MM DD, YYYY')} up to the present 

                    <b>${details[`visa_reason_of_staying`]}</b>

                </p>
                
                <p style="text-indent: 5em;">It is further certified that <b>${details[`${personType}_fullname`]}</b> is not a resident of Barangay Bahay Toro.</p>

                <p style="text-indent: 5em;" >This certification is being issued in support of his/her application for <b>VISA EXTENSION (9G), </b> and for whatever legal purpose it may serve.</p>
            `
        },

        { purpose: 'ESTATE TAX RESIDENCY',
            message:
            `
                ${message_header}
                ${message_greeting}

                <p style="text-indent: 5em;">
                    This is to certify that as per documents submitted and inquiry conducted, the deceased 
                    <b>${details[`beneficiary_fullname`]}</b>, 
                    has been a resident of 
                    <b>${details[`beneficiary_address`]}</b>,
                    until his untimely death on 
                    <b>${formatDate(details[`date_of_death`],'MM DD, YYYY')}</b>.
                </p>
                
                <p style="text-indent: 5em;" >This certification is issued this ${formattedDate} upon the request of <b>${details['client_fullname']}</b> for whatever legal purpose it may serve.</p>
            `
        },
        { purpose: 'FAMILY HOME',
            message:
            `
            ${message_header}
            ${message_greeting}

            <p style="text-indent: 5em;">
                This is to certify that as per documents submitted and inquiry conducted the deceased 
                <b>${details[`family_home_fathers_name`]}</b> and
                <b>${details[`family_home_mothers_name`]}</b>,
                has been a resident of 
                <b>${details[`family_home_address`]}</b>,
                until their death.
            </p>

            <p style="text-indent: 5em;" >Further, certify that the property existing in the above-mentioned address is their family home.</p>

            
            <p style="text-indent: 5em;" >This certification is issued this ${formattedDate} upon the request of <b>${details['client_fullname']}</b>, ${details['relationship_to_beneficiary'].toLowerCase()} of the deceased  for <b>BIR</b> purposes.</p>
            `
        },
    ];



 
 
    const matchingTemplate = templates.find(p => 
        p.purpose.toUpperCase() === details.cert_purpose.toUpperCase()
      );

      useEffect(() => {
          updateHasPhoto(matchingTemplate?.with_picture === 'true');
          updateHasThumbmark(matchingTemplate?.with_thumbmark === 'true');
          updateHasSignature(matchingTemplate?.with_signature === 'true' && details[`${personType}_fullname`]);
      }, [details])

    const getMessage = () => {
        if (matchingTemplate) {
            return matchingTemplate?.message || 'template not found'
        }
    };



    return (
        <>
            <div dangerouslySetInnerHTML={{ __html: getMessage() }} />
        </>
    );
}

export default DynamicMessage;